import React, { useCallback, useContext } from 'react';
import { get } from 'lodash-es';
import { Checkbox } from '../../../Checkbox';
import { Skeleton } from '../../../Skeleton';
import { StickTo } from '../../Table.decl';
import { InlineActions } from '../InlineActions/InlineActions';
import { TableData } from '../TableData/TableData';
import { TableRootContext } from '../TableRoot/context';
import { TextCell } from '../TextCell/TextCell';
import { TableRow, ActionsTableData, SkeletonWrapper } from './styled';

var Row = function Row(_ref) {
  var data = _ref.data,
      columns = _ref.columns,
      actions = _ref.actions,
      actionsType = _ref.actionsType,
      disabled = _ref.disabled,
      selectable = _ref.selectable,
      selectDisabled = _ref.selectDisabled,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      onSelectChange = _ref.onSelectChange,
      onClick = _ref.onClick;

  var _useContext = useContext(TableRootContext),
      loading = _useContext.loading,
      recordAttributeIdentifier = _useContext.recordAttributeIdentifier;

  var hasActions = typeof actions === 'function' || !!(actions && actions.length);
  var renderCell = useCallback(function (col, data, index) {
    var value = get(data, col.id);

    if (col.renderer) {
      return col.renderer(data, value, index);
    }

    return /*#__PURE__*/React.createElement(TextCell, null, value);
  }, []);
  var handleRowClick = useCallback(function () {
    var _window$getSelection;

    // check if there's a text selection in the page
    var currentSelection = (_window$getSelection = window.getSelection()) == null ? void 0 : _window$getSelection.toString();

    if (!currentSelection) {
      // don't trigger onRowClick event in case the user just wanted to select the value of a cell
      onClick == null ? void 0 : onClick(data);
    }
  }, [onClick, data]);
  var preventRowClick = useCallback(function (evt) {
    evt.stopPropagation();
  }, []);
  return /*#__PURE__*/React.createElement(TableRow, {
    key: data[recordAttributeIdentifier],
    selected: selected,
    disabled: disabled,
    clickable: !!onClick,
    onClick: handleRowClick
  }, selectable && /*#__PURE__*/React.createElement(TableData, {
    stickTo: StickTo.Left,
    selected: selected,
    width: "48px",
    onClick: preventRowClick
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: selected,
    disabled: selectDisabled || disabled,
    onChange: function onChange(checked) {
      return onSelectChange(data, checked);
    },
    size: "small"
  })), columns.map(function (column, index) {
    return /*#__PURE__*/React.createElement(TableData, {
      key: column.id,
      selected: selected,
      textAlign: column.textAlign
    }, loading ? /*#__PURE__*/React.createElement(SkeletonWrapper, null, /*#__PURE__*/React.createElement(Skeleton, null)) : renderCell(column, data, index));
  }), hasActions && /*#__PURE__*/React.createElement(ActionsTableData, {
    stickTo: StickTo.Right,
    selected: selected,
    onClick: preventRowClick
  }, loading ? /*#__PURE__*/React.createElement(Skeleton, null) : /*#__PURE__*/React.createElement(InlineActions, {
    data: data,
    actions: actions,
    actionsType: actionsType
  })));
};

var MemoizedRow = /*#__PURE__*/React.memo(Row);
export { MemoizedRow as Row };